import Tooltip from "@mui/material/Tooltip";
import { Box, Button } from "@mui/material";
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import TimeRangeGraph from "./TimeRangeGraph";
import CloseIcon from "@mui/icons-material/Close";
import { LineChart } from "@mui/x-charts";
import PerformanceChart from "./PerformanceChart";
import dayjs from "dayjs";

export default function GraphButton({ row }) {
  const [open, setOpen] = useState(false);

  const [selectedTimeRangeGraph, setSelectedTimeRangeGraph] =
    useState("last7Days");

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setTimeRangeGraph(initialTimeRange());
    setSelectedTimeRangeGraph("last7Days");
  };

  const initialTimeRange = () => {
    const today = dayjs();
    return [today.subtract(7, "day"), today];
  };

  const [timeRangeGraph, setTimeRangeGraph] = useState(initialTimeRange());

  const rangeDatesEjeX = () => {
    const dates = [];
    const start = timeRangeGraph[0];
    const end = timeRangeGraph[1];
    for (let i = start; i.isBefore(end); i = i.add(1, "day")) {
      dates.push(i.format("DD MMM"));
    }
    return dates;
  };

  const cpcData = [2, 5.5, 2, 8.5, 1.5, 5, 3, 2, 1, 4, 1, 9, 2, 5.5, 2, 8.5];

  const cvrData = [3, 2, 1, 4, 1, 9, 2, 5.5, 2, 8.5, 1.5, 5, 3, 2, 1, 4];

  const title = `${row.campaignName}`;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Tooltip title="Ver gráfico">
        <Box component="span" sx={{ display: "flex" }}>
          <Button
            variant="text"
            sx={{ p: 0, minWidth: "auto" }}
            onClick={handleOpen}
          >
            <GraphIcon />
          </Button>
        </Box>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
      >
        <Stack direction="column" spacing={2} padding={2}>
          <DialogTitle id="alert-dialog-title">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              {/* Titulo Izquierda*/}
              <Stack direction="column" alignItems={"flex-start"} gap={1}>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: "24px",
                    lineHeight: "32px",
                    color: "#101828",
                  }}
                >
                  {title}
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#6A7282",
                  }}
                >
                  Análisis del rendimiento de la campaña
                </Typography>
              </Stack>
              {/*  Derecha */}
              <Stack direction="row" alignItems="center" gap={2}>
                <TimeRangeGraph
                  date={timeRangeGraph}
                  setDate={setTimeRangeGraph}
                  selectedTimeRange={selectedTimeRangeGraph}
                  setSelectedTimeRange={setSelectedTimeRangeGraph}
                />
                <Button
                  onClick={handleClose}
                  variant="text"
                  sx={{ p: 1, minWidth: "auto", width: "auto", height: "100%" }}
                >
                  <CloseIcon
                    sx={{ color: "#6A7282", width: "32px", height: "32px" }}
                  />
                </Button>
              </Stack>
            </Stack>
          </DialogTitle>
        </Stack>
        <DialogContent>
          <Stack
            direction="column"
            spacing={2}
            sx={{
              backgroundColor: "#F9FAFB",
              borderRadius: "8px",
              padding: "16px",
              border: "0.62px solid #E5E7EB",
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "17px",
                color: "#101828",
                padding: "16px",
              }}
            >
              Análisis de Tendencias de CPC y CVR
            </Typography>
            <LineChart
              xAxis={[
                {
                  data: rangeDatesEjeX(),
                  scaleType: "band",
                },
              ]}
              yAxis={[
                { id: "cpc-axis", label: "CPC ($)" },
                { id: "cvr-axis", label: "CVR (%)" },
              ]}
              leftAxis="cpc-axis"
              rightAxis="cvr-axis"
              series={[
                {
                  data: rangeDatesEjeX().map((date, index) => cpcData[index]),
                  label: "CPC",
                  color: "#3B82F6",
                  yAxisKey: "cpc-axis",
                  valueFormatter: (value) => `$${value}`,
                },
                {
                  data: rangeDatesEjeX().map((date, index) => cvrData[index]),
                  label: "CVR",
                  color: "#8B5CF6",
                  yAxisKey: "cvr-axis",
                  valueFormatter: (value) => `${value}%`,
                },
              ]}
              width={1000}
              height={300}
              margin={{ top: 20, bottom: 20 }}
            />
          </Stack>
          <Divider sx={{ margin: 2 }} />
          <Stack
            direction="column"
            spacing={2}
            sx={{
              backgroundColor: "#F9FAFB",
              borderRadius: "8px",
              padding: "16px",
              border: "0.62px solid #E5E7EB",
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "17px",
                color: "#101828",
                padding: "16px",
              }}
            >
              Análisis de Tendencias de CPC y CVR
            </Typography>
            <PerformanceChart />
          </Stack>
        </DialogContent>
        {/* Dialog Actions */}
        <DialogActions>
          <Stack
            direction="row"
            justifyContent="flex-end"
            justifyItems="flex-end"
            spacing={2}
            alignItems="center"
            paddingX={2}
          >
            {/* Cancel Button */}
            <Button
              onClick={handleClose}
              variant="outline"
              sx={{
                fontFamily: "Roboto",
                fontWeight: "500px",
                fontSize: "14px",
                color: "#354887",
                height: "32px",
                maxWidth: "167px",
                textTransform: "uppercase",
                border: "1px solid #354887",
                "&:hover": {
                  backgroundColor: "#F5F5F5",
                  borderColor: "#2A3B6F",
                  color: "#2A3B6F",
                },
              }}
            >
              Cerrar
            </Button>
            {/* <ConfirmExitDialog handleClose={handleClose} /> */}
          </Stack>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

const GraphIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 3V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H21"
        stroke="black"
        strokeOpacity="0.38"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 9L14 14L10 10L7 13"
        stroke="black"
        strokeOpacity="0.38"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
